import * as fs from "fs";
import { PostEffectsInput } from "./PostEffectsPipeline";
import { PostEffect } from "./PostEffect";

export class FadePostEffect extends PostEffect {
  private readonly fadeColorLocation: WebGLUniformLocation;

  constructor(gl: WebGL2RenderingContext) {
    super(
      gl,
      "Fade",
      fs.readFileSync(__dirname + "/effects/fade.frag", "utf8"),
    );

    this.fadeColorLocation = gl.getUniformLocation(this.shader, "fadeColor")!;
  }

  protected setUniforms(input: PostEffectsInput) {
    super.setUniforms(input);
    this.gl.uniform4fv(this.fadeColorLocation, input.fadeColor);
  }
}
